// extracted by mini-css-extract-plugin
export default {"toggle":"HotelViewToggle_toggle__brG0G","active":"HotelViewToggle_active__yosmF"};